export default __webpack_public_path__ + "static/media/Head_3_Ear_1_C3.508f9268.svg";